<!-- /src/components/Course/Sidebar.vue -->
<template>
  <aside class="sidebar course-sidebar">
    <ul class="course-sidebar__action-bar">
      <li class="course-sidebar__action-bar__item">
        <button
          class="button button--medium button--shadow button--withIcon"
          :class="bookmarkClasses"
          @click.stop.prevent="addBookmark"
        >
          <span class="button__icon">
            <i v-if="bookmarkLoading" class="icon fas fa-spinner fa-pulse"></i>
            <i v-else-if="bookmarked" class="icon fas fa-bookmark"></i>
            <i v-else class="icon far fa-bookmark"></i>
          </span>
          <span class="button__text">{{ bookmarkText }}</span>
        </button>
      </li>
    </ul>

    <header class="course-sidebar__header">
      <h1 class="course-sidebar__headerTitle">{{ post.title.rendered }}</h1>
    </header>

    <div class="sidebar__taxies">
      <TaxonomyGroup
        v-for="(taxGroup, int) in taxiesGroup"
        :key="int"
        sessionType="courses"
        :label="taxGroup.label"
        :queryProp="taxGroup.queryProp"
        :taxies="taxGroup.taxies"
        :itemStyle="taxGroup.style"
      />
    </div>
  </aside>
</template>

<script>
import { taxiesGroup } from '@/mixins/postSidebarMixin.js'
import postMixin from '@/mixins/postMixin'

export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },

  mixins: [taxiesGroup, postMixin],
}
</script>

<style scoped>
.course-sidebar {
  &__action-bar {
    width: 100%;
    margin: 0 0 1rem 0;
    list-style: none;
    font-size: 0.7em;
    /* display: grid;
    grid-template-columns: auto auto;
    grid-gap: 1em; */

    &__item {
      margin: 0;
      padding: 0;
      position: relative;
      .button {
        width: 100%;
      }

      &--active {
        .session__action-bar__item__dropdown {
          opacity: 1;
        }
      }
    }
  }

  &__header {
    margin-bottom: 1rem;

    &Title {
      color: var(--brandPrimary);
      margin: 0;
      flex: 1;
      font-size: 1.65rem;
      font-weight: var(--fontWeightBold);
      line-height: 1;
    }
  }

  &__meta {
    display: flex;
    color: var(--black);
    font-size: 0.6rem;
    font-weight: var(--fontWeightSemibold);
    margin-top: 0.5rem;

    &__item {
      &:after {
        content: '.';
        margin: 0 5px;
        transform: translateY(-3px);
        display: inline-block;
      }

      &:last-child:after {
        content: '';
      }
    }
  }

  /* &__taxies {
    &__group {
      font-size: 0.6rem;

      &Title {
        display: block;
        text-transform: uppercase;
        color: var(--gray);
        margin-bottom: 0.25rem;
      }

      &Items {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        color: var(--black);
        margin-bottom: 0.5rem;

        &__item {
          font-size: 0.6rem;
          background-color: var(--lightGray);
          padding: 0.4rem 0.75rem;
          margin-bottom: 0.5rem;
          border-radius: var(--borderRadiusSmall);

          a {
            color: inherit;

            &:hover {
              color: var(--brandPrimary);
            }
          }
        }

        &--inline {
          flex-direction: row;

          .course-sidebar__taxies__groupItems__item {
            margin-right: 0.5rem;

            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
    }
  } */
}
</style>
